/* @flow */

export type SetAction = {type: "SET_CONFIRMATION_EVENTS", events: Array<Object>};

export type Action = SetAction;

type State = {+events: Array<Object>, receiptUrl: string};

let initialState = { events: [], receiptUrl: "" };

export function confirmation(state: State = initialState, action:Action): State {
    if(action.type === "SET_CONFIRMATION_EVENTS") {
        let newState = {...state};
        newState.events = action.events;
        return newState;
    }else if(action.type === "SET_RECEIPT_URL") {
        let newState = {...state};
        newState.receiptUrl = action.url;
        return newState;
    } else {
        return state;
    }
}
